// app/javascript/controllers/ai_clone_domains_controller.js
import { Controller } from "@hotwired/stimulus"

// Genera dinamicamente, in base al numero di copie richiesto, una riga per
// ciascuna versione (Vx) con un campo dominio con autocompletamento
// (riusa il controller autocomplete-domains). Cambiando il numero di
// copie le righe vengono ricostruite, preservando per indice gli eventuali
// domini già scelti.
export default class extends Controller {
  static targets = ["quantityInput", "body"]
  static values = {
    baseVersion: Number,
    autocompleteUrl: String,
    maxQuantity: Number
  }

  connect() {
    this.render()
  }

  render() {
    const quantity = this.currentQuantity()
    const previousValues = this.currentValues()

    this.bodyTarget.innerHTML = ""

    for (let i = 0; i < quantity; i++) {
      const version = `V${this.baseVersionValue + i + 1}`
      const previous = previousValues[i] || { id: "", text: "" }
      this.bodyTarget.appendChild(this.buildRow(version, previous))
    }
  }

  currentQuantity() {
    const raw = parseInt(this.quantityInputTarget.value, 10)
    const quantity = Number.isNaN(raw) ? 1 : raw
    const max = this.maxQuantityValue || quantity

    return Math.min(Math.max(quantity, 1), max)
  }

  // Valori attualmente inseriti nelle righe esistenti, per indice (non per
  // versione: se la quantità cambia le versioni successive si spostano,
  // ma è più utile mantenere quanto scritto riga per riga).
  currentValues() {
    return Array.from(this.bodyTarget.querySelectorAll("tr")).map(tr => ({
      id: tr.querySelector('input[type="hidden"]')?.value || "",
      text: tr.querySelector('input[type="text"]')?.value || ""
    }))
  }

  buildRow(version, previous) {
    const tr = document.createElement("tr")

    const versionCell = document.createElement("td")
    versionCell.className = "align-middle text-center fw-bold"
    versionCell.style.width = "80px"
    versionCell.textContent = version
    tr.appendChild(versionCell)

    const domainCell = document.createElement("td")
    domainCell.className = "position-relative"
    domainCell.dataset.controller = "autocomplete-domains"
    domainCell.dataset.autocompleteDomainsUrlValue = this.autocompleteUrlValue

    const input = document.createElement("input")
    input.type = "text"
    input.className = "form-control"
    input.setAttribute("autocomplete", "off")
    input.value = previous.text
    input.dataset.autocompleteDomainsTarget = "input"
    input.dataset.action = "input->autocomplete-domains#search"

    const hidden = document.createElement("input")
    hidden.type = "hidden"
    hidden.name = `copy_domain_ids[${version}]`
    hidden.value = previous.id
    hidden.dataset.autocompleteDomainsTarget = "id"

    const results = document.createElement("ul")
    results.dataset.autocompleteDomainsTarget = "results"
    results.className = "list-group list-unstyled ps-0 mb-0 position-absolute w-100 shadow rounded-3 bg-light d-none"
    results.style.zIndex = "1050"
    results.style.maxHeight = "240px"
    results.style.overflowY = "auto"

    domainCell.append(input, hidden, results)
    tr.appendChild(domainCell)

    return tr
  }
}
